import React from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import BRSRSidebar from "../../../../Layout/BRSRSidebar";
import Principle5 from "./Principle5";

const index = () => {
  return (
    <MainDashboardLayout sidebar={<BRSRSidebar />}>
      <Principle5 />
    </MainDashboardLayout>
  );
};

export default index;
